import { Badge } from "@/components/ui/badge";
import { pipelineStageDisplayLabel } from "@shared/proposalPipelineStage";

type Props = {
  pipelineStage?: string | null;
  className?: string;
};

export default function ProposalPipelineStageBadge({ pipelineStage, className }: Props) {
  const label = pipelineStageDisplayLabel(pipelineStage);
  const stage = String(pipelineStage ?? "").toLowerCase();
  const variant =
    stage === "draft"
      ? "secondary"
      : stage === "lost"
        ? "destructive"
        : stage === "completed"
          ? "default"
          : "outline";

  return (
    <Badge variant={variant} className={className}>
      {label}
    </Badge>
  );
}
